import { render, staticRenderFns } from "./DetailConsortium.vue?vue&type=template&id=9ac39a0e&scoped=true"
import script from "./DetailConsortium.vue?vue&type=script&lang=js"
export * from "./DetailConsortium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac39a0e",
  null
  
)

export default component.exports